import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon, LockIcon } from 'lucide-react';
import { XPIndicator } from './XPIndicator';
import { Button } from './ui/Button';
import { useLocale } from '../contexts/LocaleContext';
import { useProgress } from '../contexts/ProgressContext';

/**
 * The single locked-Post treatment. Clear about the rule, never punitive,
 * and always reading the gate from the progression engine.
 */
export function PostGate() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const progress = useProgress();
  return <div className="rounded-card border border-sand-line bg-sand-deep/60 p-2" data-id="element-1257" data-mp="1bd3w1dse9w0h">
      <p className="flex items-center gap-1 text-[12px] font-medium text-deep" data-id="element-1258" data-mp="1bb0upxlskggg">
        <LockIcon size={13} aria-hidden="true" data-id="element-1259" data-mp="1gbop8t98bfff" />
        {t('create.post.locked', {
        gate: progress.postGateXp
      })}
      </p>
      <p className="bee-num mt-1 text-[15px] font-bold text-deep" data-id="element-1260" data-mp="3d6tf04x01u4b">
        {t('create.gate.progress', {
        xp: progress.dailyXp,
        gate: progress.postGateXp
      })}
      </p>
      <div className="mt-2" data-id="element-1261" data-mp="3jcjy2o0fic3t">
        <XPIndicator xp={progress.dailyXp} showGate={false} data-id="element-1262" data-mp="3ek0khr1qrgz0" />
      </div>
      <p className="mt-1 text-[11.5px] leading-snug text-muted" data-id="element-1263" data-mp="3ehxo8p9zwrlu">
        {t('create.gate.reason')}
      </p>
      <Button variant="gold" fullWidth className="mt-2" onClick={() => navigate('/check')} data-id="element-1264" data-mp="34lkwvy1xapu9">
        {t('create.gate.cta')}
        <ArrowRightIcon size={16} data-id="element-1265" data-mp="63fcacgxorwy" />
      </Button>
    </div>;
}